//const remotebase = process.env.REACT_APP_COUCHDB_DEVELOPMENT_URL
const remotebase = localStorage.getItem("remote_base");
const dbName = localStorage.getItem("db_name");

export const remote = {
    usermanagement: `${remotebase}/usermanagement`,
    wilayah: `${remotebase}/wilayah`,
    data: `${remotebase}/data`,
    users: `${remotebase}/_users`,
    data_kk: `${remotebase}/data_kk`,
    data_kb: `${remotebase}/data_kb`,
    data_pk: `${remotebase}/data_pk`,
    data_rekap: `${remotebase}/data_rekap`,
    //05Des2019
    //data_bkkbn: `${remotebase}/data_bkkbn_dev`,
    data_bkkbn: `${remotebase}/${dbName}`,
    cloudant_url: `${remotebase}`
}

export const local = {
    data_kk: 'data_kk',
    data_kb: 'data_kb',
    data_pk: 'data_pk',
    data_rekap: 'data_rekap',
    //05Des2019
    data_bkkbn: `data_bkkbn`,
}
